import moment from 'moment';

import { User } from './interfaces/User';

export const convertDate = (createdAtStr: string): string => {
  const date = moment(createdAtStr);
  return date.format('dddd, MMMM D, YYYY');
};

export const convertTime = (timeStr: string): string => {
  const time = moment(timeStr, 'HH:mm:ss');
  return time.format('h:mm A');
};
export const keyFromYoutubeLiveLink = (liveLink: string): string => {
  try {
    const url = new URL(liveLink);

    if (
      url.hostname.includes('youtube.com') ||
      url.hostname.includes('youtu.be')
    ) {
      if (url.hostname === 'youtu.be') {
        return url.pathname.replace('/', '');
      }

      const videoIdFromQuery = url.searchParams.get('v');
      if (videoIdFromQuery) {
        return videoIdFromQuery;
      }

      const pathMatch = url.pathname.match(/\/(embed|live)\/([a-zA-Z0-9_-]+)/);
      if (pathMatch && pathMatch[2]) {
        return pathMatch[2];
      }
    }
  } catch (err) {
    return '';
  }

  return '';
};

export const isSubscriptionActive = (userData: User | undefined) => {
  const graceDate = userData?.subscription?.grace_days_ended_at;
  return graceDate ? new Date(graceDate) >= new Date() : false;
};

export const hasPreviouslySubscribed = (userData: User | undefined) => {
  return userData && userData?.features?.length > 0;
};

export const isPlatformSubscriptionActive = (userData: User | undefined) => {
  return userData?.platform_subscription ? true : false;
};

export function normalizeProductName(title: string): string {
  const patterns: RegExp[] = [
    // Book (Hardcopy) + Course
    /\s*(?:[-–—]\s*)?book\s*\(\s*hardcopy\s*\)\s*\+\s*course\s*$/iu,

    // Digital / Hard formats with optional Copy / SB
    /\s*(?:[-–—]\s*)?(?:\(\s*)?(?:digital\s*(?:access|copy)?|hard\s*copy|hardcopy|hard\s*cover|hardcover)(?:\s*(?:\(\s*copy\s*\)|copy|sb))?\s*(?:\))?\s*$/iu,

    // Digital Access SB (no hyphen)
    /\s+digital\s+access\s+sb\s*$/iu,

    // eBook and Course variants (including leading separators)
    /\s*(?:[-–—]\s*)?(?:ebook|e-book|course)\s*$/iu,

    // Combo formats (including leading separators and variants like [eBook + Course])
    /\s*(?:[-–—]\s*)?(?:combo\s*)?\[\s*ebook\s*\+\s*(?:hardcopy|course)(?:\s*\+\s*course)?\s*\]\s*$/iu,
  ];

  let result = title;

  for (const pattern of patterns) {
    result = result.replace(pattern, '');
  }

  return result.trim();
}

export const getTrackOrderLink = (shippingDetails: any): string | null => {
  if (!shippingDetails) return null;
  const awbId = shippingDetails.awb_id;
  const channel = shippingDetails.channel?.toLowerCase();

  if (!awbId || !channel) return null;

  const amazonTrackOrderLink = 'https://track.amazon.in/tracking/';
  const shiprocketTrackOrderLink = 'https://shiprocket.co/tracking/';

  if (channel === 'amazon') {
    return `${amazonTrackOrderLink}${awbId}`;
  } else if (channel === 'shiprocket') {
    return `${shiprocketTrackOrderLink}${awbId}`;
  }
  return null;
};

